/**
 * Where the version on screen sits relative to the one that counts:
 * - `current` — the version in force / the revision the document points at,
 * - `older` — a superseded version,
 * - `future` — a version that exists but has not taken effect yet,
 * - `latest` — the most recent version of something that is not in force at
 *   all, where calling it "current" would claim too much.
 *
 * Shared by the consolidation activation-date dropdown and the workspace
 * revision indicator so "you are not reading the current version" is worded
 * and coloured the same wherever it is said (LAR-423).
 */
export type DocumentVersionStatus = "current" | "older" | "future" | "latest";

export type DocumentVersionStatusLabels = {
  /** Full wording, for a badge that has to stand on its own. */
  long: string;
  /** Short wording, where the surrounding UI already says "version". */
  short: string;
};

export const DOCUMENT_VERSION_STATUS_LABELS: Record<
  DocumentVersionStatus,
  DocumentVersionStatusLabels
> = {
  current: { long: "Aktuel version", short: "Aktuel" },
  older: { long: "Ældre version", short: "Ældre" },
  future: { long: "Fremtidig version", short: "Fremtidig" },
  latest: { long: "Seneste version", short: "Seneste" },
};
